<template>
	<div v-if="engine">
		<h2 class="page-title">
			<router-link :to="`/sites/${engine.site}/engines/${engine.id}`">
    			<i class="icon-minimal-left tim-icons" />
			</router-link>
			Revisione <span v-if="engine"> per {{engine.name}} <span class="text-muted small">/ {{engine.registrationNumber}}</span> <span v-if="site"> - {{site.name}}</span></span>
		</h2>
    	<revision-form
        :site="site"
        create
        :is-saving="isSaving"
        :model="model"
        :on-submit="addRevisionSubmit"
        :submit-message="`${isSaving ? 'Creazione in corso... Attendere':'Crea'}`" />
  </div>
  <loading v-else/>
</template>
<script>
import axios from 'axios'
import RevisionForm from '@/components/Revisions/RevisionForm.vue'
// import SitesTable from './SitesTable.vue';
import { mapState, mapActions } from 'vuex'


export default{
  computed: {
    ...mapState({
      user: state => state.account.user,
      engine: state => state.engines.engine,
      site: state => state.sites.site,
    })
  },
  components: {
    RevisionForm
  },
  async mounted() {
    this.getEngine({id:this.$route.params.engineId})
    this.model.workers = [this.user._id]
  },
  data() {
  	return {
      isSaving: false,
  		model: {
        number: null,
        revisionDate: new Date(),
        phase: 'technical',
        workers: [],
        workedDetails: {
          days: [{
            day: new Date(),
          }]
        },
        techinicalDetails: {},
        productsUsed: [{}],
  		}
  	}
  },
  watch: {
    engine(newValue) {
      if (newValue !== null){
        this.model.engine = newValue.id
        this.getSite(newValue.site)
      }
    },
    site( newValue) {
      if ( newValue && newValue.referenceOrderLabel ){
        this.model.referenceOrderLabel = newValue.referenceOrderLabel
      }
      if ( newValue && newValue.referenceOrder ){
        this.model.referenceOrder = newValue.referenceOrder
      }
    }
  },
  methods: {
    ...mapActions('engines', {
      getEngine: 'get'
    }),
    ...mapActions('sites', {
      getSite: 'get'
    }),
    ...mapActions('revisions', {
      create: 'create'
    }),
    async addRevisionSubmit() {
      if (! this.isSaving){
        this.isSaving = true
        await this.create({
                engineId: this.$route.params.engineId,
                revision: this.model
                })
      }
      // this.isSaving = false
    }
  },
}	
</script>